import { NewBox as Box } from "@bca/ui-library";

import LoadingTableHead from "./LoadingTableHead";
import LoadingTableRow1 from "./LoadingTableRow1";
import LoadingTableRow2 from "./LoadingTableRow2";
import LoadingFilters from "./LoadingFilters";
import LoadingSearch from "./LoadingSearch";

const NonMobileLoadingTable: React.FunctionComponent = () => {
  return (
    <Box marginTop="xxl" data-testid="loading-table">
      <Box display="flex" flexDirection="row">
        <LoadingSearch />
        <LoadingFilters />
      </Box>
      <table>
        <thead>
          <LoadingTableHead />
        </thead>
        <tbody>
          <LoadingTableRow1 />
          <LoadingTableRow1 />
          <LoadingTableRow2 />
          <LoadingTableRow2 />
        </tbody>
      </table>
    </Box>
  );
};

export default NonMobileLoadingTable;
